import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Tooltip from '../../../../../../../../../components/Tooltip';

import { useWindowSize } from '../../../../../../../../../utils/hooks/useWindowSize';

const Rate = ({ rate, provider, providerRate }) => {
  const { config } = useSelector((state) => state.services);

  const providerCurrency = provider?.currency;
  const panelCurrency = config.currency;

  const { width } = useWindowSize();

  return (
    <div className={classNames('services-import__list-service-price')}>
      {providerRate && providerCurrency && providerCurrency !== panelCurrency ? (
        <Tooltip
          placement={width < 479 ? 'top' : 'left'}
          tooltipClass={width < 479 ? 'tooltip__top' : 'tooltip__left'}
          text={`${providerRate} ${providerCurrency || ''}`}
        >
          <span className="cursor-help services-import__list-service-rate">
            ≈
            {' '}
            {rate}
          </span>
        </Tooltip>
      ) : (
        <span className="services-import__list-service-rate">{rate}</span>
      )}
    </div>
  );
};

Rate.propTypes = {
  rate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  provider: PropTypes.object,
  providerRate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
export default Rate;
